import { Button, Card, Typography } from '@mui/material';
import { Control, UseFormHandleSubmit } from 'react-hook-form';

import FormViewFieldLayout from 'portal/src/components/common/forms/FormViewFieldLayout';
import useSnackbarHandler from 'portal/src/utils/Snackbar/useSnackbarHandler';

import { LineItemFormFields } from './LineItemForm.fields';
import { getFields } from './MeterReadingForm.field';

import { useBillFormContext } from '../BillFormContext';

type MeterReadingProps = Pick<
  LineItemFormFields,
  | 'meterCurrentReading'
  | 'meterPreviousReading'
  | 'meterReadingMultiplier'
  | 'unitOfMeasure'
>;

const MeterReadingForm = ({
  setCalculatedUsage,
  control,
  handleSubmit,
}: {
  setCalculatedUsage: (usage: number) => void;
  control: Control<LineItemFormFields>;
  handleSubmit: UseFormHandleSubmit<LineItemFormFields>;
}) => {
  const { billIsUsedInAllocations } = useBillFormContext();
  const snackbarHandler = useSnackbarHandler();

  const submitForm = (data: LineItemFormFields) => {
    const {
      meterCurrentReading,
      meterPreviousReading,
      meterReadingMultiplier,
      unitOfMeasure,
    }: MeterReadingProps = data;
    const usage =
      ((meterCurrentReading || 0) - (meterPreviousReading || 0)) *
      (meterReadingMultiplier || 1);

    setCalculatedUsage(usage);
    snackbarHandler.info(`Usage updated to ${usage}${unitOfMeasure}.`);
  };

  const formFieldsConfig = getFields();

  return (
    <Card
      variant="outlined"
      sx={{ borderColor: 'grey.400', padding: 1.5, width: '100%' }}
    >
      <Typography gutterBottom sx={{ color: 'text.primary', fontSize: 13 }}>
        Enter meter readings to help calculate usage:
      </Typography>
      <FormViewFieldLayout
        control={control}
        mainFieldsConfig={formFieldsConfig}
        columnNumber={3}
        isDeactivated={billIsUsedInAllocations}
        isReadOnly={billIsUsedInAllocations}
      />
      <Button
        color="primary"
        disabled={billIsUsedInAllocations}
        onClick={handleSubmit(submitForm)}
        size="small"
        type="button"
        variant="outlined"
        sx={{ marginTop: 1 }}
      >
        Calculate Usage
      </Button>
    </Card>
  );
};

export default MeterReadingForm;
